import graphql__058cd194a91f9bee53e1 from "./__generated__/PageRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import Page from "../Pages/Page";

const PageRoute = props => {
  const { id } = useParams();

  return (
    <AppQueryRenderer
      key={id}
      query={PageRouteQuery}
      variables={{ id }}
      component={Page}
      additionalProps={props}
    />
  );
};

const PageRouteQuery = graphql__058cd194a91f9bee53e1;

export default PageRoute;
